import { Injectable } from '@angular/core';
import mixpanel from 'mixpanel-browser';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MixpanelService {

  private mixpanelToken: string;
  //private mixpanel: Mixpanel;
  /**
   * constructor
   * get mixpanel token and initialize
   */
  constructor() {
    this.mixpanelToken = environment.mixpanelToken; // Replace with your actual Mixpanel token

   // this.init();
  }

  /**
   * Initialize mixpanel.
   */
  init(): void {
  
    mixpanel.init(this.mixpanelToken, 
      {
        autocapture: true, 
        track_pageview: true,
        record_sessions_percent: 100,
        persistence: 'localStorage'
        
      }, 'mixpanel');
  }


  /**
   * Create new Alias for user
   * Call this method only once in user lifecycle
   *
   * @param {string} alias
   */
  createAlias(alias: string) {
    mixpanel.alias(alias, mixpanel.get_distinct_id());
  }

  /**
   * Identify User
   *
   * @param {string} alias
   */
  identify(alias: string) {
    mixpanel.identify(alias);
  }

  /**
   * Push new action to mixpanel.
   *
   * @param {string} id Name of the action to track. (Event name)
   * @param {*} [action={}] Actions object with custom properties.(Event properties)
   * @memberof MixpanelService
   */
  track(id: string, action: any = {}): void {
    mixpanel.track(id, action);
  }

  /**
   * setup mixpannel
   *
   */
  setup() {
    //mixpanel.loggingEnabled = false;
    this.setSuperProperties({ Platform: 'web' });
  }

  /**
   * setPeople
   * Store user profiles in Mixpanel's People Analytics product
   * @param {Object} properties
   */
  setPeople(properties: any = {}): void {
    mixpanel.people.set(properties);
  }

  /**
   * setSuperProperties
   *
   * @param {object} properties
   */
  setSuperProperties(properties) {
    mixpanel.register(properties);
  }

  /**
   * sendEvent
   *
   * @param {string} event
   * @param {object} properties
   */
  sendEvent(event: string, properties?) {
    if (properties) {
      mixpanel.track(event, properties);
    } else {
      this.trackEvent(event);
    }
  }

  /**
   * trackEvent
   * @param {string} event
   */
  trackEvent(event: string) {
    mixpanel.track(event);
  }

  /**
   * Reset Mixpanel
   */
  logout() {
    mixpanel.reset();
  }

  /** Force start a replay capture */
startSessionRecording() {

  try {
    // @ts-ignore
    mixpanel.start_session_recording?.();
    console.log('[Mixpanel] Session recording started');
  } catch (err) {
    console.error('Failed to start session recording:', err);
  }
}

/** Force stop a replay capture */
stopSessionRecording() {
  
  try {
    // @ts-ignore
    mixpanel.stop_session_recording?.();
    console.log('[Mixpanel] Session recording stopped');
  } catch (err) {
    console.error('Failed to stop session recording:', err);
  }
}


  
}
